import "./fullAppLoader.css";
import { useSelector } from "react-redux";

const FullAppLoader = () => {
  const isDarkMode = useSelector((state) => state?.theme?.darkMode);

  return (
    <div
      className={
        isDarkMode
          ? "full-app-loader full-app-loader-dark"
          : "full-app-loader full-app-loader-light"
      }
    >
      <div className="spinner-wrapper">
        <div className="custom-spinner"></div>
      </div>
    </div>
  );
};

export default FullAppLoader;
